import React from 'react';

import Loading from 'components/Loading';

export default function CourseListEmpty() {
    return <Loading />;
}
